<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <RmLoading :loading="loading" />
    <div
      v-if="config.public.vkPixel"
      v-once
      v-html="noscriptHtml"
    />
    <ClientOnly>
      <RmModal />
      <Notifications />
    </ClientOnly>
  </div>
</template>

<script setup>
import { useLoadingIndicator } from '#app/composables/loading-indicator'
import { onMounted, ref } from 'vue'
import Notifications from '~/components/layout/notifications.vue'
import RmLoading from '~/components/shared/rm_loading.vue'
import RmModal from '~/components/shared/rm_modal.vue'

const indicator = useLoadingIndicator()
const loading = computed(() => indicator.isLoading.value)

const config = useRuntimeConfig()

const noscriptHtml = ref('')

onMounted(() => {
  noscriptHtml.value = `<noscript><div><img :src="https://top-fwz1.mail.ru/counter?id=${config.public.vkPixel};js=na" style="position:absolute;left:-9999px;" alt="Top.Mail.Ru" /></div></noscript>`
})
</script>
